import { isProd } from 'src/config';

import maps from './maps';
import weakMaps from './weak-maps';

const exportMaps = isProd ? weakMaps : maps;

export const EDITOR_FOCUS = exportMaps.EDITOR_FOCUS;
export const EDITOR_TO_INPUT_HANDLER = exportMaps.EDITOR_TO_INPUT_HANDLER;
export const EDITOR_TO_TAB_STATE = exportMaps.EDITOR_TO_TAB_STATE;
export const EDITOR_TO_UPDATE_CONTEXT = exportMaps.EDITOR_TO_UPDATE_CONTEXT;
